// import React, { useState, useRef, useEffect } from "react";
// import { Link } from "react-router-dom";
// import { ToastContainer } from "react-toastify";

// // import all assets
// import logo from "../assets/logo.png";
// import dd from "../assets/DD.png";
// import ar from "../assets/Ar.png";
// import emojiLeft from '../assets/emoji-left.svg';
// import emojiRight from '../assets/emoji-right.svg';
// import emojiParty from '../assets/emoji-party.svg';
// import emojiConfetti from '../assets/emoji-confetti.svg';

// const Header = () => {
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const [openDropdown, setOpenDropdown] = useState(null);
//   const [isServicesOpen, setIsServicesOpen] = useState(false);
//   const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);
//   const [isCompanyOpen, setIsCompanyOpen] = useState(false);
//   const navRef = useRef(null);

//   const toggleDropdown = (menu) => {
//     setOpenDropdown(openDropdown === menu ? null : menu);
//   };

//   const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);
//   const toggleServicesDropdown = () => setIsServicesOpen(!isServicesOpen);
//   const toggleIndustriesDropdown = () => setIsIndustriesOpen(!isIndustriesOpen);
//   const toggleCompanyDropdown = () => setIsCompanyOpen(!isCompanyOpen);

//   // close dropdown when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (navRef.current && !navRef.current.contains(event.target)) {
//         setOpenDropdown(null);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   return (
//     <>
//       {/* Toast Notifications */}
//       <ToastContainer position="top-right" autoClose={3000} />

//       {/* Top Celebration Bar */}
//       <div className="top-0 z-50 w-full">
//         <div className="relative bg-[#FFE9AC] py-2 px-3 text-center text-gray-800 text-[13px] sm:text-sm md:text-base font-medium flex items-center justify-center">
//           <div className="absolute left-0 top-1/2 transform -translate-y-1/2">
//             <img src={emojiLeft} alt="emoji" className="h-5 w-5 sm:h-6 sm:w-6" />
//           </div>
//           <div className="flex flex-wrap items-center justify-center gap-1 px-6">
//             <span className="hidden sm:flex items-center gap-1">
//               <img src={emojiConfetti} alt="confetti" className="h-4 w-4 sm:h-5 sm:w-5" />
//             </span>
//             <span className="text-[11px] sm:text-[12px] md:text-[13px]">
//               We are proud to announce that we have completed&nbsp;
//               <span className="text-green-700 font-semibold">6 successful years!</span>
//             </span>
//             <span className="hidden sm:flex items-center gap-1">
//               <img src={emojiParty} alt="party" className="h-4 w-4 sm:h-5 sm:w-5" />
//               <img src={emojiConfetti} alt="confetti" className="h-4 w-4 sm:h-5 sm:w-5" />
//             </span>
//           </div>
//           <div className="absolute right-0 top-1/2 transform -translate-y-1/2">
//             <img src={emojiRight} alt="emoji" className="h-5 w-5 sm:h-6 sm:w-6" />
//           </div>
//         </div>
//       </div>

//       {/* Main Header */}
//       <header className="sticky top-0 z-50 w-full bg-white border-b border-gray-100 shadow-sm">
//         <div className="mx-auto flex max-w-screen-xl items-center justify-between px-4 py-2 md:px-8">
//           {/* Logo */}
//           <div className="flex items-center space-x-2">
//             <Link to="/">
//               <img src={logo} alt="Logo" className="h-8 w-auto" />
//             </Link>
//           </div>

//           {/* Mobile Hamburger */}
//           <button
//             className="lg:hidden flex items-center"
//             onClick={toggleMobileMenu}
//             aria-label="Toggle mobile menu"
//           >
//             <svg
//               className="h-6 w-6 text-gray-800"
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth="2"
//                 d={
//                   isMobileMenuOpen
//                     ? "M6 18L18 6M6 6l12 12"
//                     : "M4 6h16M4 12h16M4 18h16"
//                 }
//               />
//             </svg>
//           </button>
//           <nav
//       ref={navRef}
//       className="hidden lg:flex items-center space-x-6 text-sm font-medium text-gray-800 ml-13"
//     >
//       {/* --- Services Dropdown --- */}
//       <div className="relative">
//         <div className="flex items-center gap-1">
//           <a
//             href="#"
//             className="text-black hover:text-black flex items-center"
//             onClick={(e) => {
//               e.preventDefault();
//               toggleDropdown('services');
//             }}
//           >
//             Services
//             <img
//               src={dd}
//               alt="Dropdown arrow"
//               className={`h-1 w-2 ml-2 mt-1 transition-transform duration-300 ${
//                 openDropdown === 'services' ? 'rotate-180' : 'rotate-0'
//               }`}
//             />
//           </a>
//         </div>

//         {openDropdown === 'services' && (
//           <div className="absolute top-full left-0 mt-2 w-56 bg-white text-black rounded-lg shadow-lg py-2 z-50">
//             {[
//               { to: "/services/ai-services/", label: "AI Services" },
//               { to: "/services/web-development/", label: "Web Development" },
//               { to: "/services/mobile-app-development/", label: "Mobile App Development" },
//               { to: "/services/software-consulting/", label: "Software Consulting" },
//               { to: "/services/third-party-integration/", label: "Third Party Integration" },
//               { to: "/services/custom-development/", label: "Custom Development" },
//               { to: "/services/enterprise-application/", label: "Enterprise Application" },
//               { to: "/services/digital-transformation/", label: "Digital Transformation" },
//             ].map((item) => (
//               <Link
//                 key={item.to}
//                 to={item.to}
//                 className="relative block px-4 py-2 hover:bg-gray-100 transition-all duration-300 group flex items-center justify-between"
//               >
//                 <div className="flex items-center">
//                   <span className="absolute left-0 top-0 h-full w-1 bg-[#00A339] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
//                   <span className="ml-2 text-xs">{item.label}</span>
//                 </div>
//                 <img
//                   src={ar}
//                   alt="Right arrow"
//                   className="h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
//                 />
//               </Link>
//             ))}
//           </div>
//         )}
//       </div>

//       {/* --- Industries Dropdown --- */}
//       <div className="relative">
//         <div className="flex items-center gap-1">
//           <a
//             href="#"
//             className="text-black hover:text-black flex items-center"
//             onClick={(e) => {
//               e.preventDefault();
//               toggleDropdown('industries');
//             }}
//           >
//             Industries
//             <img
//               src={dd}
//               alt="Dropdown arrow"
//               className={`h-1 w-2 ml-2 mt-1 transition-transform duration-300 ${
//                 openDropdown === 'industries' ? 'rotate-180' : 'rotate-0'
//               }`}
//             />
//           </a>
//         </div>

//         {openDropdown === 'industries' && (
//            <div className="absolute top-full left-0 mt-2 w-56 bg-white text-black rounded-lg shadow-lg py-2 z-50">
//             {[

//               { to: "/industries/logistics/", label: "Logistics" },
//               { to: "/industries/healthcare/", label: "Healthcare" },
//               { to: "/industries/financial-services/", label: "Financial Services" },
//               { to: "/industries/education/", label: "Education" },
//               { to: "/industries/hospitality/", label: "Hospitality" },
//               { to: "/industries/entertainment/", label: "Entertainment" },
//               { to: "/industries/energy/", label: "Energy" },
//               { to: "/industries/warehouse/", label: "Warehouse" },
//               { to: "/industries/manufacture/", label: "Manufacture" },
//               { to: "/industries/ecommerce/", label: "E-commerce" },
//             ].map((item) => (
//               <Link
//                 key={item.to}
//                 to={item.to}
//                 className="relative block px-4 py-2 hover:bg-gray-100 transition-all duration-300 group flex items-center justify-between"
//               >
//                 <div className="flex items-center">
//                   <span className="absolute left-0 top-0 h-full w-1 bg-[#00A339] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
//                   <span className="ml-2 text-xs">{item.label}</span>
//                 </div>
//                 <img
//                   src={ar}
//                   alt="Right arrow"
//                   className="h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
//                 />
//               </Link>
//             ))}
//           </div>
//         )}
//       </div>

//       {/* --- Company Dropdown --- */}
//       <div className="relative">
//         <div className="flex items-center gap-1">
//           <a
//             href="#"
//             className="text-black hover:text-black flex items-center"
//             onClick={(e) => {
//               e.preventDefault();
//               toggleDropdown('company');
//             }}
//           >
//             Company
//             <img
//               src={dd}
//               alt="Dropdown arrow"
//               className={`h-1 w-2 ml-2 mt-1 transition-transform duration-300 ${
//                 openDropdown === 'company' ? 'rotate-180' : 'rotate-0'
//               }`}
//             />
//           </a>
//         </div>

//         {openDropdown === 'company' && (
//           <div className="absolute top-full left-0 mt-2 w-56 bg-white text-black rounded-lg shadow-lg py-2 z-50">
//             {[
//               { to: "/company/our-advantages/", label: "Our advantages" },
//               { to: "/company/our-story/", label: "Our Story" },
//               { to: "/company/people-of-lentera/", label: "People of Lentera" },
//               { to: "/company/our-brand/", label: "Our Brand" },
//               { to: "/company/careers/", label: "Careers" },
//               { to: "https://blog.lentera.in/", label: "Blogs", external: true },
//               { to: "https://www.lentera.in/contact-us/", label: "Support us", external: true },
//               // { to: "/company/certifications/", label: "Certifications" },
//               // { to: "/company/careers/", label: "Careers" },
//               { to: "/company/blog/", label: "Blog"},

//             ].map((item) =>
//               item.external ? (
//                 <a
//                   key={item.to}
//                   href={item.to}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="relative block px-4 py-2 hover:bg-gray-100 transition-all duration-300 group flex items-center justify-between"
//                 >
//                   <div className="flex items-center">
//                     <span className="absolute left-0 top-0 h-full w-1 bg-[#00A339] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
//                     <span className="ml-2 text-xs">{item.label}</span>
//                   </div>
//                   <img
//                     src={ar}
//                     alt="Right arrow"
//                     className="h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
//                   />
//                 </a>
//               ) : (
//                 <Link
//                   key={item.to}
//                   to={item.to}
//                   className="relative block px-4 py-2 hover:bg-gray-100 transition-all duration-300 group flex items-center justify-between"
//                 >
//                   <div className="flex items-center">
//                     <span className="absolute left-0 top-0 h-full w-1 bg-[#00A339] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
//                     <span className="ml-2 text-xs">{item.label}</span>
//                   </div>
//                   <img
//                     src={ar}
//                     alt="Right arrow"
//                     className="h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
//                   />
//                 </Link>
//               )
//             )}
//           </div>
//         )}
//       </div>

//       {/* --- Contact Link --- */}
//       <Link to="/contact/" className="text-black hover:text-black">
//         Contact us
//       </Link>
//     </nav>
//       <button
//   onClick={() =>
//     window.location.href =
//       "https://outlook.office365.com/book/FreeConsultation@lenteratechno.onmicrosoft.com/"
//   }
//   className="w-[240px] h-[44px] rounded-full bg-green-600 px-5 py-2 text-sm font-semibold text-white hover:bg-green-700"
// >
//   Book a Free Consultation
// </button>
// {/* Mobile Menu */}
//             {isMobileMenuOpen && (
//               <div className="lg:hidden bg-white border-t border-gray-100">
//                 <nav className="flex flex-col px-4 py-4 space-y-2 text-sm font-medium text-gray-800">
//                   <div>
//                     <button
//                       className="flex items-center justify-between w-full text-black hover:text-black py-2"
//                       onClick={toggleServicesDropdown}
//                     >
//                       Services
//                       <img
//                         src={dd}
//                         alt="Dropdown arrow"
//                         className={`h-1 w-2 transition-transform duration-300 ${
//                           isServicesOpen ? 'rotate-180' : 'rotate-0'
//                         }`}
//                       />
//                     </button>
//                     {isServicesOpen && (
//                       <div className="mt-2 space-y-1">
//                         <Link
//                           to="/services/ai-services/"
//                           className="block px-4 py-2 text-xs hover:bg-gray-100"
//                           onClick={() => setIsMobileMenuOpen(false)}
//                         >
//                           Ai Services
//                         </Link>
//                         <Link
//                           to="/services/web-development/"
//                           className="block px-4 py-2 text-xs hover:bg-gray-100"
//                           onClick={() => setIsMobileMenuOpen(false)}
//                         >
//                           Web Development
//                         </Link>
//                         <Link
//                           to="/services/mobile-app-development/"
//                           className="block px-4 py-2 text-xs hover:bg-gray-100"
//                           onClick={() => setIsMobileMenuOpen(false)}
//                         >
//                           Mobile App Development
//                         </Link>
//                         <Link
//                           to="/services/software-consulting/"
//                           className="block px-4 py-2 text-xs hover:bg-gray-100"
//                           onClick={() => setIsMobileMenuOpen(false)}
//                         >
//                           Software Consulting
//                         </Link>
//                         <Link
//                           to="/services/third-party-integration/"
//                           className="block px-4 py-2 text-xs hover:bg-gray-100"
//                           onClick={() => setIsMobileMenuOpen(false)}
//                         >
//                           Third Party Integration
//                         </Link>
//                         <Link
//                           to="/services/custom-development/"
//                           className="block px-4 py-2 text-xs hover:bg-gray-100"
//                           onClick={() => setIsMobileMenuOpen(false)}
//                         >
//                           Custom Development
//                         </Link>
//                         <Link
//                           to="/services/enterprise-application/"
//                           className="block px-4 py-2 text-xs hover:bg-gray-100"
//                           onClick={() => setIsMobileMenuOpen(false)}
//                         >
//                           Enterprise Application
//                         </Link>
//                          <Link
//                           to="/services/digital-transformation/"
//                           className="block px-4 py-2 text-xs hover:bg-gray-100"
//                           onClick={() => setIsMobileMenuOpen(false)}
//                         >
//                           Digital Transformation
//                         </Link>
//                       </div>
//                     )}
//                   </div>
//                   <div>
//                     <button
//                       className="flex items-center justify-between w-full text-black hover:text-black py-2"
//                       onClick={toggleIndustriesDropdown}
//                     >
//                       Industries
//                       <img
//                         src={dd}
//                         alt="Dropdown arrow"
//                         className={`h-1 w-2 transition-transform duration-300 ${
//                           isIndustriesOpen ? 'rotate-180' : 'rotate-0'
//                         }`}
//                       />
//                     </button>
//                     {isIndustriesOpen && (
//                       <div className="mt-2 space-y-1">

//                         <Link
//                           to="/industries/logistics/"
//                           className="block px-4 py-2 text-xs hover:bg-gray-100"
//                           onClick={() => setIsMobileMenuOpen(false)}
//                         >
//                           Logistics
//                         </Link>
//                         <Link
//                           to="/industries/healthcare/"
//                           className="block px-4 py-2 text-xs hover:bg-gray-100"
//                           onClick={() => setIsMobileMenuOpen(false)}
//                         >
//                           Healthcare
//                         </Link>
//                         <Link
//                           to="/industries/financial-services/"
//                           className="block px-4 py-2 text-xs hover:bg-gray-100"
//                           onClick={() => setIsMobileMenuOpen(false)}
//                         >
//                           Financial Services
//                         </Link>
//                         <Link
//                           to="/industries/education/"
//                           className="block px-4 py-2 text-xs hover:bg-gray-100"
//                           onClick={() => setIsMobileMenuOpen(false)}
//                         >
//                           Education
//                         </Link>
//                         <Link
//                           to="/industries/hospitality/"
//                           className="block px-4 py-2 text-xs hover:bg-gray-100"
//                           onClick={() => setIsMobileMenuOpen(false)}
//                         >
//                           Hospitality
//                         </Link>
//                         <Link
//                           to="/industries/entertainment/"
//                           className="block px-4 py-2 text-xs hover:bg-gray-100"
//                           onClick={() => setIsMobileMenuOpen(false)}
//                         >
//                           Entertainment
//                         </Link>
//                         <Link
//                           to="/industries/energy/"
//                           className="block px-4 py-2 text-xs hover:bg-gray-100"
//                           onClick={() => setIsMobileMenuOpen(false)}
//                         >
//                           Energy
//                         </Link>
//                         <Link
//                           to="/industries/warehouse/"
//                           className="block px-4 py-2 text-xs hover:bg-gray-100"
//                           onClick={() => setIsMobileMenuOpen(false)}
//                         >
//                           Warehouse
//                         </Link>
//                          <Link
//                           to="/industries/manyufacture/"
//                           className="block px-4 py-2 text-xs hover:bg-gray-100"
//                           onClick={() => setIsMobileMenuOpen(false)}
//                         >
//                           Manufacture
//                         </Link>
//                         <Link
//                           to="/industries/ecommerce/"
//                           className="block px-4 py-2 text-xs hover:bg-gray-100"
//                           onClick={() => setIsMobileMenuOpen(false)}
//                         >
//                           E-commerce
//                         </Link>
//                       </div>
//                     )}
//                   </div>
//                   <div>
//                     <button
//                       className="flex items-center justify-between w-full text-black hover:text-black py-2"
//                       onClick={toggleCompanyDropdown}
//                     >
//                       Company
//                       <img
//                         src={dd}
//                         alt="Dropdown arrow"
//                         className={`h-1 w-2 transition-transform duration-300 ${
//                           isCompanyOpen ? 'rotate-180' : 'rotate-0'
//                         }`}
//                       />
//                     </button>
//                     {isCompanyOpen && (
//                       <div className="mt-2 space-y-1">
//                         <Link
//                           to="/company/our-advantages/"
//                           className="block px-4 py-2 text-xs hover:bg-gray-100"
//                           onClick={() => setIsMobileMenuOpen(false)}
//                         >
//                           Our advantages
//                         </Link>
//                         <Link
//                           to="/company/our-story/"
//                           className="block px-4 py-2 text-xs hover:bg-gray-100"
//                           onClick={() => setIsMobileMenuOpen(false)}
//                         >
//                           Our Story
//                         </Link>
//                         <Link
//                           to="/company/people-of-lentera/"
//                           className="block px-4 py-2 text-xs hover:bg-gray-100"
//                           onClick={() => setIsMobileMenuOpen(false)}
//                         >
//                           People Of Lentera
//                         </Link>
//                          <Link
//                           to="/company/our-brand/"
//                           className="block px-4 py-2 text-xs hover:bg-gray-100"
//                           onClick={() => setIsMobileMenuOpen(false)}
//                         >
//                           Our Brand
//                         </Link>
//                         {/* <Link
//                         to="/company/certifications/"
//                         className="block px-4 py-2 text-xs hover:bg-gray-100"
//                         onClick={() => setIsMobileMenuOpen(false)}
//                       >
//                         Certifications
//                       </Link>   */}
//                     <a
//   href="https://blog.lentera.in/"
//   target="_blank"
//   rel="noopener noreferrer"
//   className="block px-4 py-2 text-xs hover:bg-gray-100"
//   onClick={() => setIsMobileMenuOpen(false)}
// >
//   Blogs
// </a>
// <Link
//                         to="/company/careers/"
//                         className="block px-4 py-2 text-xs hover:bg-gray-100"
//                         onClick={() => setIsMobileMenuOpen(false)}
//                       >
//                        Careers
//                       </Link>
//                         {/* <Link
//                           to="/certifications"
//                           className="block px-4 py-2 text-xs hover:bg-gray-100"
//                           onClick={() => setIsMobileMenuOpen(false)}
//                         >
//                           Certifications
//                         </Link> */}
//                       <a
//   href="https://www.lentera.in/contact-us/"
//   target="_blank"
//   rel="noopener noreferrer"
//   className="block px-4 py-2 text-xs hover:bg-gray-100"
//   onClick={() => setIsMobileMenuOpen(false)}
// >
//   Support us
// </a>

//                       </div>
//                     )}
//                   </div>
//                   <Link
//                     to="/Contact/"
//                     className="block py-2 text-sm hover:bg-gray-100"
//                     onClick={() => setIsMobileMenuOpen(false)}
//                   >
//                     Contact us
//                   </Link>
//                   {/* <button className="flex items-center gap-2 py-2 text-sm font-medium text-gray-700">
//                     <img
//                       src={ind}
//                       alt="India Flag"
//                       className="h-4 w-4 rounded-full"
//                     />
//                     India (English)
//                     <ChevronDown className="h-4 w-4" />
//                   </button> */}
//           {/* <button
//                  onClick={handleClick}
//   className="block py-2 text-sm font-semibold text-white bg-green-600 rounded-full hover:bg-green-700"
//   // onClick={() => {
//   //   const section = document.getElementById("contact-section");
//   //   if (section) {
//   //     section.scrollIntoView({ behavior: "smooth" });
//   //   }
//   // }}
// >
//   Get a Free Quote
// </button> */}
//   <button
//   onClick={() =>
//     window.location.href =
//       "https://outlook.office365.com/book/FreeConsultation@lenteratechno.onmicrosoft.com/"
//   }
//   className="w-[240px] h-[44px] rounded-full bg-green-600 px-5 py-2 text-sm font-semibold text-white hover:bg-green-700"
// >
//   Book a Free Consultation
// </button>
//                 </nav>
//               </div>
//             )}
//           {/* Desktop Navigation */}
//           {/* (paste your nav dropdowns here, same as your code) */}
//         </div>
//       </header>
//     </>
//   );
// };

// export default Header;
import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";

// import all assets
import logo from "../assets/logo.png";
import dd from "../assets/DD.png";
import ar from "../assets/Ar.png";
import emojiLeft from '../assets/emoji-left.svg';
import emojiRight from '../assets/emoji-right.svg';
import emojiParty from '../assets/emoji-party.svg';
import emojiConfetti from '../assets/emoji-confetti.svg';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const navRef = useRef(null);

  const toggleDropdown = (menu) => {
    setOpenDropdown(openDropdown === menu ? null : menu);
  };

  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);

  // close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLinkClick = () => {
    setOpenDropdown(null);
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      {/* Toast Notifications */}
      <ToastContainer position="top-right" autoClose={3000} />

      {/* Top Celebration Bar */}
      <div className="top-0 z-50 w-full">
        <div className="relative bg-[#FFE9AC] py-2 px-3 text-center text-gray-800 text-[13px] sm:text-sm md:text-base font-medium flex items-center justify-center">
          <div className="absolute left-0 top-1/2 transform -translate-y-1/2">
            <img src={emojiLeft} alt="emoji" className="h-5 w-5 sm:h-6 sm:w-6" />
          </div>
          <div className="flex flex-wrap items-center justify-center gap-1 px-6">
            <span className="hidden sm:flex items-center gap-1">
              <img src={emojiConfetti} alt="confetti" className="h-4 w-4 sm:h-5 sm:w-5" />
            </span>
            <span className="text-[11px] sm:text-[12px] md:text-[13px]">
              We are proud to announce that we have completed&nbsp;
              <span className="text-green-700 font-semibold">6 successful years!</span>
            </span>
            <span className="hidden sm:flex items-center gap-1">
              <img src={emojiParty} alt="party" className="h-4 w-4 sm:h-5 sm:w-5" />
              <img src={emojiConfetti} alt="confetti" className="h-4 w-4 sm:h-5 sm:w-5" />
            </span>
          </div>
          <div className="absolute right-0 top-1/2 transform -translate-y-1/2">
            <img src={emojiRight} alt="emoji" className="h-5 w-5 sm:h-6 sm:w-6" />
          </div>
        </div>
      </div>

      {/* Main Header */}
      <header className="sticky top-0 z-50 w-full bg-white border-b border-gray-100 shadow-sm">
        <div className="mx-auto flex max-w-screen-xl items-center justify-between px-4 py-2 md:px-8">
          {/* Logo */}
          <div className="flex items-center space-x-2">
            <Link to="/" onClick={handleLinkClick}>
              <img src={logo} alt="Logo" className="h-8 w-auto" />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav
            ref={navRef}
            className="hidden lg:flex items-center space-x-6 text-sm font-medium text-gray-800 ml-13"
          >
            {/** Services Dropdown */}
            <DropdownMenu
              title="Services"
              items={[
                { to: "/services/ai-services/", label: "AI Services" },
                { to: "/services/web-development/", label: "Web Development" },
                { to: "/services/mobile-app-development/", label: "Mobile App Development" },
                { to: "/services/software-consulting/", label: "Software Consulting" },
                { to: "/services/third-party-integration/", label: "Third Party Integration" },
                { to: "/services/custom-development/", label: "Custom Development" },
                { to: "/services/enterprise-application/", label: "Enterprise Application" },
                { to: "/services/digital-transformation/", label: "Digital Transformation" },
              ]}
              openDropdown={openDropdown}
              toggleDropdown={toggleDropdown}
              handleLinkClick={handleLinkClick}
            />

            {/** Industries Dropdown */}
            <DropdownMenu
              title="Industries"
              items={[
                { to: "/industries/logistics/", label: "Logistics" },
                { to: "/industries/healthcare/", label: "Healthcare" },
                { to: "/industries/financial-services/", label: "Financial Services" },
                { to: "/industries/education/", label: "Education" },
                { to: "/industries/hospitality/", label: "Hospitality" },
                { to: "/industries/entertainment/", label: "Entertainment" },
                { to: "/industries/energy/", label: "Energy" },
                { to: "/industries/warehouse/", label: "Warehouse" },
                { to: "/industries/manufacture/", label: "Manufacture" },
                { to: "/industries/ecommerce/", label: "E-commerce" },
              ]}
              openDropdown={openDropdown}
              toggleDropdown={toggleDropdown}
              handleLinkClick={handleLinkClick}
            />

            {/** Company Dropdown */}
            <DropdownMenu
              title="Company"
              items={[
                { to: "/company/our-advantages/", label: "Our advantages" },
                { to: "/company/our-story/", label: "Our Story" },
                { to: "/company/people-of-lentera/", label: "People of Lentera" },
                { to: "/company/our-brand/", label: "Our Brand" },
                { to: "/company/careers/", label: "Careers" },
                { to: "/blogs", label: "Blogs", external: true },
                // { to: "https://www.lentera.in/contact-us/", label: "Support us", external: true },
              ]}
              openDropdown={openDropdown}
              toggleDropdown={toggleDropdown}
              handleLinkClick={handleLinkClick}
            />

            {/* Contact Link */}
            <Link to="/contact/" onClick={handleLinkClick} className="text-black hover:text-black">
              Contact us
            </Link>
          </nav>

          {/* Book a Free Consultation - Desktop */}
          <a
            href="https://outlook.office365.com/book/FreeConsultation@lenteratechno.onmicrosoft.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="hidden lg:block w-[240px] h-[44px] rounded-full bg-green-600 px-5 py-2 text-sm font-semibold text-white hover:bg-green-700 text-center leading-[28px]"
          >
            Book a Free consultation
          </a>


          {/* Mobile Hamburger */}
          <button
            className="lg:hidden flex items-center"
            onClick={toggleMobileMenu}
            aria-label="Toggle mobile menu"
          >
            <svg
              className="h-6 w-6 text-gray-800"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d={
                  isMobileMenuOpen
                    ? "M6 18L18 6M6 6l12 12"
                    : "M4 6h16M4 12h16M4 18h16"
                }
              />
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <MobileMenu handleLinkClick={handleLinkClick} />
        )}
      </header>
    </>
  );
};

export default Header;

// ------------------ DropdownMenu Component ------------------
const DropdownMenu = ({ title, items, openDropdown, toggleDropdown, handleLinkClick }) => (
  <div className="relative">
    <div className="flex items-center gap-1">
      <a
        href="#"
        className="text-black hover:text-black flex items-center"
        onClick={(e) => {
          e.preventDefault();
          toggleDropdown(title.toLowerCase());
        }}
      >
        {title}
        <img
          src={dd}
          alt="Dropdown arrow"
          className={`h-1 w-2 ml-2 mt-1 transition-transform duration-300 ${openDropdown === title.toLowerCase() ? 'rotate-180' : 'rotate-0'
            }`}
        />
      </a>
    </div>

    {openDropdown === title.toLowerCase() && (
      <div className="absolute top-full left-0 mt-2 w-56 bg-white text-black rounded-lg shadow-lg py-2 z-50">
        {items.map((item) =>
          item.external ? (
            <a
              key={item.to}
              href={item.to}
              target="_blank"
              rel="noopener noreferrer"
              onClick={handleLinkClick}
              className="relative block px-4 py-2 hover:bg-gray-100 transition-all duration-300 group flex items-center justify-between"
            >
              <span className="ml-2 text-xs">{item.label}</span>
              <img src={ar} alt="Right arrow" className="h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            </a>
          ) : (
            <Link
              key={item.to}
              to={item.to}
              onClick={handleLinkClick}
              className="relative block px-4 py-2 hover:bg-gray-100 transition-all duration-300 group flex items-center justify-between"
            >
              <span className="ml-2 text-xs">{item.label}</span>
              <img src={ar} alt="Right arrow" className="h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            </Link>
          )
        )}
      </div>
    )}
  </div>
);

// ------------------ MobileMenu Component ------------------
const MobileMenu = ({ handleLinkClick }) => {
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);
  const [isCompanyOpen, setIsCompanyOpen] = useState(false);

  return (
    <div className="lg:hidden bg-white border-t border-gray-100">
      <nav className="flex flex-col px-4 py-4 space-y-2 text-sm font-medium text-gray-800">
        {/* Services */}
        <MobileDropdown
          title="Services"
          isOpen={isServicesOpen}
          setIsOpen={setIsServicesOpen}
          items={[
            { to: "/services/ai-services/", label: "AI Services" },
            { to: "/services/web-development/", label: "Web Development" },
            { to: "/services/mobile-app-development/", label: "Mobile App Development" },
            { to: "/services/software-consulting/", label: "Software Consulting" },
            { to: "/services/third-party-integration/", label: "Third Party Integration" },
            { to: "/services/custom-development/", label: "Custom Development" },
            { to: "/services/enterprise-application/", label: "Enterprise Application" },
            { to: "/services/digital-transformation/", label: "Digital Transformation" },
          ]}
          handleLinkClick={handleLinkClick}
        />

        {/* Industries */}
        <MobileDropdown
          title="Industries"
          isOpen={isIndustriesOpen}
          setIsOpen={setIsIndustriesOpen}
          items={[
            { to: "/industries/logistics/", label: "Logistics" },
            { to: "/industries/healthcare/", label: "Healthcare" },
            { to: "/industries/financial-services/", label: "Financial Services" },
            { to: "/industries/education/", label: "Education" },
            { to: "/industries/hospitality/", label: "Hospitality" },
            { to: "/industries/entertainment/", label: "Entertainment" },
            { to: "/industries/energy/", label: "Energy" },
            { to: "/industries/warehouse/", label: "Warehouse" },
            { to: "/industries/manufacture/", label: "Manufacture" },
            { to: "/industries/ecommerce/", label: "E-commerce" },
          ]}
          handleLinkClick={handleLinkClick}
        />

        {/* Company */}
        <MobileDropdown
          title="Company"
          isOpen={isCompanyOpen}
          setIsOpen={setIsCompanyOpen}
          items={[
            { to: "/company/our-advantages/", label: "Our advantages" },
            { to: "/company/our-story/", label: "Our Story" },
            { to: "/company/people-of-lentera/", label: "People Of Lentera" },
            { to: "/company/our-brand/", label: "Our Brand" },
            { to: "/company/careers/", label: "Careers" },
            { to: "/blogs", label: "Blogs", external: true },
            // { to: "https://www.lentera.in/contact-us/", label: "Support us", external: true },
          ]}
          handleLinkClick={handleLinkClick}
        />

        {/* Contact */}
        <Link to="/contact/" onClick={handleLinkClick} className="block py-2 text-sm hover:bg-gray-100">
          Contact us
        </Link>

        {/* Mobile Consultation Button */}
        <a
          href="https://outlook.office365.com/book/FreeConsultation@lenteratechno.onmicrosoft.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="block w-full rounded-full bg-green-600 px-5 py-2 text-sm font-semibold text-white hover:bg-green-700 text-center"
        >
          Book a Free Consultation
        </a>

      </nav>
    </div>
  );
};

// ------------------ MobileDropdown Component ------------------
const MobileDropdown = ({ title, isOpen, setIsOpen, items, handleLinkClick }) => (
  <div>
    <button
      className="flex items-center justify-between w-full text-black hover:text-black py-2"
      onClick={() => setIsOpen(!isOpen)}
    >
      {title}
      <img src={dd} alt="Dropdown arrow" className={`h-1 w-2 transition-transform duration-300 ${isOpen ? 'rotate-180' : 'rotate-0'}`} />
    </button>
    {isOpen && (
      <div className="mt-2 space-y-1">
        {items.map((item) =>
          item.external ? (
            <a
              key={item.to}
              href={item.to}
              target="_blank"
              rel="noopener noreferrer"
              onClick={handleLinkClick}
              className="block px-4 py-2 text-xs hover:bg-gray-100"
            >
              {item.label}
            </a>
          ) : (
            <Link
              key={item.to}
              to={item.to}
              onClick={handleLinkClick}
              className="block px-4 py-2 text-xs hover:bg-gray-100"
            >
              {item.label}
            </Link>
          )
        )}
      </div>
    )}
  </div>
);
